import { render, staticRenderFns } from "./vMadeWithMovement.vue?vue&type=template&id=bdf72c7c&scoped=true"
import script from "./vMadeWithMovement.vue?vue&type=script&lang=js"
export * from "./vMadeWithMovement.vue?vue&type=script&lang=js"
import style0 from "./vMadeWithMovement.vue?vue&type=style&index=0&id=bdf72c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf72c7c",
  null
  
)

export default component.exports